module.exports = __webpack_public_path__ + "static/media/banner-products.eea7c6d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-products.jpg
// module id = 405
// module chunks = 0